import React from 'react';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';
import styled from '@mui/system/styled';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

const PageHeader = (props) => {
	const { label } = props;
	const location = useLocation();

	const PageHeaderContainer = styled('div')(({ theme }) => ({
		display: 'flex',
		justifyContent: 'space-between',
		alignContent: 'center',
		margin: theme.spacing(2)
	}));

	const GenerateBreadcrumbs = () => {
		const path = location.pathname.split('/');
		delete path[0];

		path.unshift(' ');

		return (
			<Breadcrumbs aria-label="breadcrumb">
				{path.map((link) => {
					return (
						<Link
							color="inherit"
							key={link}
							underline="none"
							sx={{ cursor: 'default' }}
							// href={`${link}`} // TODO, figure out which routes are allowed.
						>
							{link}
						</Link>
					);
				})}
			</Breadcrumbs>
		);
	};

	return (
		<PageHeaderContainer>
			<Typography variant="subtitle" sx={{ fontWeight: 'bold' }}>
				{label}
			</Typography>
			{GenerateBreadcrumbs()}
		</PageHeaderContainer>
	);
};

PageHeader.propTypes = {
	label: PropTypes.string
};

export default PageHeader;
